var transitionTypeData = ['fadeInFadeOut', 'fadeInSwipeLeft', 'shakeInFadeOut'];
export default transitionTypeData;